import { useQuery } from "@apollo/client";

import { GET_ATTACHABLE_WORKER_POOLS_FOR_SCAN } from "./gql";

const useAttachableWorkerPools = (spaceId: string | undefined) => {
  const { data, error, loading } = useQuery(GET_ATTACHABLE_WORKER_POOLS_FOR_SCAN, {
    variables: { id: spaceId ?? "" },
    skip: !spaceId,
  });

  return {
    workerPools: data?.attachableWorkerPoolsInSpace ?? [],
    error,
    loading,
  };
};

export default useAttachableWorkerPools;
